/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/1/18
 * Copyright All Rights Reserved
 */

import {
  TOKEN_RESPONSE,
  TOKEN_DESTROY,
} from 'constants/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOKEN_RESPONSE:
      if (action.error) {
        return {};
      }
      return action.payload.user;
    case TOKEN_DESTROY:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./js/reducers/usersReducer/currentUser.js